// extracted by mini-css-extract-plugin
export default {"wrapper":"HavanaModerna_wrapper__qEpxc"};